import { render, staticRenderFns } from "./T3AutoResearcherBox.vue?vue&type=template&id=2bb36fc4&scoped=true"
import script from "./T3AutoResearcherBox.vue?vue&type=script&lang=js"
export * from "./T3AutoResearcherBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb36fc4",
  null
  
)

export default component.exports